import React from 'react';
import Header from '../components/Header/Header';

export const App = () => (
    <div>
        <Header />
    </div>
);

export default App;